import '@eec/ui/jetons.css';
import '@eec/ui/polices';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import './styles-reseau.css';
import './refonte-tokens.css';
import './refonte.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Application } from './Application';
import { appliquerPreferencesInitiales } from './preferences/FournisseurPreferences';

appliquerPreferencesInitiales();

const racine = document.getElementById('racine');
if (!racine) throw new Error('Élément #racine absent');
createRoot(racine).render(
  <StrictMode>
    <Application />
  </StrictMode>,
);
